module.exports = __webpack_public_path__ + "assets/img/智骑宝364 283px.71eb8cb0.jpg";